import React, { useEffect, useState } from "react";
import BsModal from "./BsModal";
import Pending from "./Pending";
import Preloader from "./Preloader";
export default function Offline() {
  let [visible, changeVisible] = useState(false);

  const goOnline = () => {
    changeVisible(false);
  };

  const goOffline = () => {
    changeVisible(true);
  };

  useEffect(() => {
    window.addEventListener("onlineGoOnline", goOnline);
    window.addEventListener("onlineGoOffline", goOffline);
    return function () {
      window.removeEventListener("onlineGoOnline", goOnline);
      window.removeEventListener("onlineGoOffline", goOffline);
    };
  });

  return (
    <BsModal className="pending-modal" show={visible} center>
      <Pending />
      <h4>Сервер недоступен...</h4>
    </BsModal>
  );
}
